// extracted by mini-css-extract-plugin
export default {"details":"Details_details__QSN-C","header":"Details_header__6dNzn","content":"Details_content__OjIRa"};